// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9a143160","239":"82a2a1f9","455":"a1ef4a97"}[chunkId] + ".chunk.js";
};